/**
 * FeaturePillRow — single horizontal row of all-caps feature labels separated
 * by a gold bullet. Used on every product page under the headline+descriptor.
 *
 * @example
 *   <FeaturePillRow items={["LIGHTBOX","SELECTIONS","DOWNLOADS","MUSIC SLOT"]} />
 *   <FeaturePillRow items={items} tone="dark" align="center" />
 */
import React from "react";

const TONE = {
  light: "text-[color:var(--charcoal)]/80",
  dark:  "text-[color:var(--cream)]/80",
};

export default function FeaturePillRow({
  items = [],
  tone = "dark",
  align = "left",
  className = "",
  ...rest
}) {
  if (!items.length) return null;
  const justify = align === "center" ? "justify-center" : align === "right" ? "justify-end" : "justify-start";
  return (
    <ul
      className={`flex flex-wrap items-center gap-x-3 gap-y-2 ${justify} ${TONE[tone] || TONE.dark} ${className}`}
      {...rest}
    >
      {items.map((it, i) => (
        <React.Fragment key={it + i}>
          <li className="ed-eyebrow whitespace-nowrap">{String(it).toUpperCase()}</li>
          {i < items.length - 1 ? (
            <li aria-hidden="true" className="text-[10px] leading-none text-[color:var(--gold-base)]">·</li>
          ) : null}
        </React.Fragment>
      ))}
    </ul>
  );
}
